export default "__VITE_ASSET__M5XRdBfp__"